import { render } from "./ConnectionBans.vue?vue&type=template&id=578c175a"
import script from "./ConnectionBans.vue?vue&type=script&lang=js"
export * from "./ConnectionBans.vue?vue&type=script&lang=js"

import "./ConnectionBans.vue?vue&type=style&index=0&id=578c175a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__